module.exports = __webpack_public_path__ + "img/home_bnews4_1.203e387e.png";